export function convertWebvttToData (webvtt) {
  if (!webvtt) {
    return []
  }

  // some srt file has `\r\n` line break, so the webvtt file
  // we should convert `\r\n` to `\n` first
  // should skip the first line `WEBVTT`
  const lines = webvtt.split(/\r?\n\r?\n/).slice(1)
  const result = []

  lines.forEach(line => {
    const [time, text] = line.split(/\r?\n/)
    const [start, end] = time.split(' --> ')
    result.push({
      start,
      end,
      text
    })
  })

  return result
}

export function parseCustomDuration (time) {
  let hours = 0
  let minutes = 0
  let seconds = 0
  let milliseconds = 0

  const timeParts = time.split('.')
  const mainParts = timeParts[0].split(':')

  milliseconds = parseInt(timeParts[1] || '0', 10)

  if (mainParts.length === 3) {
    // Handle HH:MM:SS format
    [hours, minutes, seconds] = mainParts.map(Number)
  } else if (mainParts.length === 2) {
    // Handle MM:SS format
    // `Duration.fromISOTime` can not handle it
    [minutes, seconds] = mainParts.map(Number)
  }

  return {
    hours,
    minutes,
    seconds,
    milliseconds
  }
}
